(() => {
  if (customElements.get('yoko-trust-badge')) return;
  customElements.define('yoko-trust-badge', class extends HTMLElement {
    connectedCallback() {
      this.preview = this.querySelector('[data-yoko-trust-preview]');
      this.app = this.querySelector('.yoko-trust-badge__app');
      if (!this.preview || !this.app) return;
      this.activate = () => {
        if (this.nativeButton) this.nativeButton.click();
        else {
          this.pending = true;
          this.preview.setAttribute('aria-busy', 'true');
        }
      };
      this.preview.addEventListener('click', this.activate);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.app, {childList:true, subtree:true});
      // Loox uses an open shadow root; watch its render as well as its host.
      customElements.whenDefined('loox-trust-badge-widget').then(() => {
        if (this.isConnected) requestAnimationFrame(() => this.sync());
      });
      this.sync();
    }
    sync() {
      const root = this.app.querySelector('loox-trust-badge-widget')?.shadowRoot;
      if (!root) return;
      if (!this.shadowObserver) {
        this.shadowObserver = new MutationObserver(() => this.sync());
        this.shadowObserver.observe(root, {childList:true, subtree:true});
      }
      const button = root.querySelector('.loox-trust-badge-widget-content-container[role="button"]');
      if (!button?.textContent.trim()) return;
      this.nativeButton = button;
      this.setAttribute('data-ready', '');
      this.observer.disconnect();
      this.shadowObserver.disconnect();
      if (this.pending) {
        this.pending = false;
        this.preview.removeAttribute('aria-busy');
        button.click();
      }
    }
    disconnectedCallback() {
      this.pending = false;
      this.nativeButton = null;
      this.preview?.removeEventListener('click', this.activate);
      this.observer?.disconnect();
      this.shadowObserver?.disconnect();
      this.shadowObserver = null;
    }
  });
})();
